// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IAccessControlType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class AccessControlType implements IAccessControlType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns Allow Unbalanced Receipt AccessControlType
    **/
    get AllowUnbalancedReceipt(): IAccessControlType {
        return this.FromId(1);
    }
    /**
        Returns Allow Long Message AccessControlType
    **/
    get AllowLongMessage(): IAccessControlType {
        return this.FromId(2);
    }
    /**
        Returns Upd Cust Detail AccessControlType
    **/
    get UpdCustDetail(): IAccessControlType {
        return this.FromId(3);
    }
    /**
        Returns Upd Cust Name AccessControlType
    **/
    get UpdCustName(): IAccessControlType {
        return this.FromId(4);
    }
    /**
        Returns Upd Cust Address AccessControlType
    **/
    get UpdCustAddress(): IAccessControlType {
        return this.FromId(5);
    }
    /**
        Returns Upd Cust Identification AccessControlType
    **/
    get UpdCustIdentification(): IAccessControlType {
        return this.FromId(6);
    }
    /**
        Returns Upd Cust Certification AccessControlType
    **/
    get UpdCustCertification(): IAccessControlType {
        return this.FromId(7);
    }
    /**
        Returns Upd Cust Contact AccessControlType
    **/
    get UpdCustContact(): IAccessControlType {
        return this.FromId(8);
    }
    /**
        Returns Upd Cust Characteristic AccessControlType
    **/
    get UpdCustCharacteristic(): IAccessControlType {
        return this.FromId(9);
    }
    /**
        Returns Upd Cust Physical Attributes AccessControlType
    **/
    get UpdCustPhysicalAttributes(): IAccessControlType {
        return this.FromId(10);
    }
    /**
        Returns Upd Cust Medical AccessControlType
    **/
    get UpdCustMedical(): IAccessControlType {
        return this.FromId(11);
    }
    /**
        Returns Upd Cust Affiliations AccessControlType
    **/
    get UpdCustAffiliations(): IAccessControlType {
        return this.FromId(12);
    }
    /**
        Returns Set Address Undeliverable AccessControlType
    **/
    get SetAddressUndeliverable(): IAccessControlType {
        return this.FromId(13);
    }
    /**
        Returns Upd ACP AccessControlType
    **/
    get UpdACP(): IAccessControlType {
        return this.FromId(14);
    }
    /**
        Returns Upd Abandoned Vehicle AccessControlType
    **/
    get UpdAbandonedVehicle(): IAccessControlType {
        return this.FromId(15);
    }
    /**
        Returns Upd Accident Processing AccessControlType
    **/
    get UpdAccidentProcessing(): IAccessControlType {
        return this.FromId(16);
    }
    /**
        Returns Upd Customer Complaint AccessControlType
    **/
    get UpdCustomerComplaint(): IAccessControlType {
        return this.FromId(17);
    }
    /**
        Returns Upd Medical Review AccessControlType
    **/
    get UpdMedicalReview(): IAccessControlType {
        return this.FromId(18);
    }
    /**
        Returns Allow PPV Mainframe Adjust AccessControlType
    **/
    get AllowPPVMainframeAdjust(): IAccessControlType {
        return this.FromId(19);
    }
    /**
        Returns Allow Law Enf Note Edit AccessControlType
    **/
    get AllowLawEnfNoteEdit(): IAccessControlType {
        return this.FromId(21);
    }
    /**
        Returns Allow View Redacted Data AccessControlType
    **/
    get AllowViewRedactedData(): IAccessControlType {
        return this.FromId(22);
    }
    /**
        Returns Allow PPV Date Range Search AccessControlType
    **/
    get AllowPPVDateRangeSearch(): IAccessControlType {
        return this.FromId(1021);
    }
    /**
        Returns CSR DL Restrictions AccessControlType
    **/
    get CSRDLRestrictions(): IAccessControlType {
        return this.FromId(1022);
    }
    /**
        Returns CSR CDL Restrictions AccessControlType
    **/
    get CSRCDLRestrictions(): IAccessControlType {
        return this.FromId(1023);
    }
    /**
        Returns Set C Restriction on License AccessControlType
    **/
    get SetCRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1024);
    }
    /**
        Returns Set D Restriction on License AccessControlType
    **/
    get SetDRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1025);
    }
    /**
        Returns MRP Restrictions AccessControlType
    **/
    get MRPRestrictions(): IAccessControlType {
        return this.FromId(1026);
    }
    /**
        Returns LECU Restrictions AccessControlType
    **/
    get LECURestrictions(): IAccessControlType {
        return this.FromId(1027);
    }
    /**
        Returns DEV Restrictions Group AccessControlType
    **/
    get DEVGroup(): IAccessControlType {
        return this.FromId(1028);
    }
    /**
        Returns Driver Services Restrictions AccessControlType
    **/
    get DriverServicesRestrictions(): IAccessControlType {
        return this.FromId(1029);
    }
    /**
        Returns Set I Restriction on License AccessControlType
    **/
    get SetIRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1030);
    }
    /**
        Returns Set J Restriction on License AccessControlType
    **/
    get SetJRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1031);
    }
    /**
        Returns Set K Restriction on License AccessControlType
    **/
    get SetKRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1032);
    }
    /**
        Returns Set L Restriction on License AccessControlType
    **/
    get SetLRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1033);
    }
    /**
        Returns Set M Restriction on License AccessControlType
    **/
    get SetMRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1034);
    }
    /**
        Returns Set N Restriction on License AccessControlType
    **/
    get SetNRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1035);
    }
    /**
        Returns Set O Restriction on License AccessControlType
    **/
    get SetORestrictionOnLicense(): IAccessControlType {
        return this.FromId(1036);
    }
    /**
        Returns Set P Restriction on License AccessControlType
    **/
    get SetPRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1037);
    }
    /**
        Returns Set Q Restriction on License AccessControlType
    **/
    get SetQRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1038);
    }
    /**
        Returns Set R Restriction on License AccessControlType
    **/
    get SetRRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1039);
    }
    /**
        Returns Set S Restriction on License AccessControlType
    **/
    get SetSRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1040);
    }
    /**
        Returns Set T Restriction on License AccessControlType
    **/
    get SetTRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1041);
    }
    /**
        Returns Set V Restriction on License AccessControlType
    **/
    get SetVRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1042);
    }
    /**
        Returns Set W Restriction on License AccessControlType
    **/
    get SetWRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1043);
    }
    /**
        Returns Set X Restriction on License AccessControlType
    **/
    get SetXRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1044);
    }
    /**
        Returns Set Y Restriction on License AccessControlType
    **/
    get SetYRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1045);
    }
    /**
        Returns Set Z Restriction on License AccessControlType
    **/
    get SetZRestrictionOnLicense(): IAccessControlType {
        return this.FromId(1046);
    }
    /**
        Returns Set 1 Restriction on License AccessControlType
    **/
    get Set1RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1047);
    }
    /**
        Returns Set 2 Restriction on License AccessControlType
    **/
    get Set2RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1048);
    }
    /**
        Returns Set 3 Restriction on License AccessControlType
    **/
    get Set3RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1049);
    }
    /**
        Returns Set 4 Restriction on License AccessControlType
    **/
    get Set4RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1050);
    }
    /**
        Returns Set 5 Restriction on License AccessControlType
    **/
    get Set5RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1051);
    }
    /**
        Returns Set 6 Restriction on License AccessControlType
    **/
    get Set6RestrictionOnLicense(): IAccessControlType {
        return this.FromId(1052);
    }
    /**
        Returns Allow View Full SSN AccessControlType
    **/
    get AllowViewFullSSN(): IAccessControlType {
        return this.FromId(1053);
    }
    /**
        Returns Update Customer Representatives AccessControlType
    **/
    get UpdCustRepresentatives(): IAccessControlType {
        return this.FromId(1055);
    }
    /**
        Returns Allow Merge Customer AccessControlType
    **/
    get AllowMergeCustomer(): IAccessControlType {
        return this.FromId(1126);
    }
    /**
        Returns Quality Check Update Assigned To AccessControlType
    **/
    get QualityCheckUpdateAssignedTo(): IAccessControlType {
        return this.FromId(1157);
    }
    /**
        Returns Upd Commercial Vehicle Trip Auth AccessControlType
    **/
    get UpdCommercialVehicleTripAuth(): IAccessControlType {
        return this.FromId(20);
    }
    /**
        Returns Allow Refund Compliance AccessControlType
    **/
    get AllowRefundCompliance(): IAccessControlType {
        return this.FromId(23);
    }
    /**
        Returns Allow View UC Vehicles AccessControlType
    **/
    get AllowViewUCVehicles(): IAccessControlType {
        return this.FromId(1054);
    }
    /**
        Returns Allow Add AZ DL AccessControlType
    **/
    get AllowAddAZDL(): IAccessControlType {
        return this.FromId(1056);
    }
    /**
        Returns Update OOP IAH AccessControlType
    **/
    get UpdOOPIAH(): IAccessControlType {
        return this.FromId(1057);
    }
    /**
        Returns Update Restricted Record AccessControlType
    **/
    get UpdRestrictedRecord(): IAccessControlType {
        return this.FromId(1058);
    }
    /**
        Returns Enter TSA Security Assessment AccessControlType
    **/
    get EnterTSASecurityAssessment(): IAccessControlType {
        return this.FromId(1059);
    }
    /**
        Returns Approve Fuel Tax Assessment AccessControlType
    **/
    get ApproveFuelTaxAssessment(): IAccessControlType {
        return this.FromId(1060);
    }
    /**
        Returns Approve Fuel Tax Adjustment AccessControlType
    **/
    get ApproveFuelTaxAdjustment(): IAccessControlType {
        return this.FromId(1061);
    }
    /**
        Returns FT Manager AccessControlType
    **/
    get FTManager(): IAccessControlType {
        return this.FromId(1062);
    }
    /**
        Returns FT Supervisor AccessControlType
    **/
    get FTSupervisor(): IAccessControlType {
        return this.FromId(1063);
    }
    /**
        Returns FT Lead AccessControlType
    **/
    get FTLead(): IAccessControlType {
        return this.FromId(1064);
    }
    /**
        Returns Set ELT Identification Type on Customer AccessControlType
    **/
    get SetELTIdentType(): IAccessControlType {
        return this.FromId(1065);
    }
    /**
        Returns Drivers Issuance No Photo AccessControlType
    **/
    get DriversIssuanceNoPhoto(): IAccessControlType {
        return this.FromId(1066);
    }
    /**
        Returns Credential Photo Admin AccessControlType
    **/
    get CredentialPhotoAdmin(): IAccessControlType {
        return this.FromId(1067);
    }
    /**
        Returns Allow Plate Order Status Update AccessControlType
    **/
    get AllowPlateOrderStatusUpdate(): IAccessControlType {
        return this.FromId(1068);
    }
    /**
        Returns Upd IRP Indicator AccessControlType
    **/
    get UpdIRPIndicator(): IAccessControlType {
        return this.FromId(1069);
    }
    /**
        Returns Add/Update Compliance Monitoring AccessControlType
    **/
    get AddUpdComplianceMonitoring(): IAccessControlType {
        return this.FromId(1070);
    }
    /**
        Returns Folio Request Hold AccessControlType
    **/
    get FRHold(): IAccessControlType {
        return this.FromId(1071);
    }
    /**
        Returns Allow Transfer Of Locked Credit AccessControlType
    **/
    get AllowTransferLockedCredit(): IAccessControlType {
        return this.FromId(1072);
    }
    /**
        Returns Allow viewing of confidential notes AccessControlType
    **/
    get AllowViewConfidentialNote(): IAccessControlType {
        return this.FromId(1073);
    }
    /**
        Returns Allow Creation of Finance Incidents AccessControlType
    **/
    get AllowCreateFinanceIncident(): IAccessControlType {
        return this.FromId(1074);
    }
    /**
        Returns Allow Creation of a duplicate 17 digit VIN AccessControlType
    **/
    get AllowCreateDupVin(): IAccessControlType {
        return this.FromId(1075);
    }
    /**
        Returns Preview Feature One AccessControlType
    **/
    get PreviewFeatureOne(): IAccessControlType {
        return this.FromId(1076);
    }
    /**
        Returns Add Update Fraud Incident Withdrawal AccessControlType
    **/
    get AddUpdFrdIncidentWithdrawal(): IAccessControlType {
        return this.FromId(1077);
    }
    /**
        Returns Allow View Omni Search Bar AccessControlType
    **/
    get AllowViewOmniSearchBar(): IAccessControlType {
        return this.FromId(1078);
    }
    /**
        Returns Edit Disposition Code 78 AccessControlType
    **/
    get EditDispositionCode78(): IAccessControlType {
        return this.FromId(1079);
    }
    /**
        Returns Accommodative Medical Snapshot AccessControlType
    **/
    get AccommodativeMedicalSnapshot(): IAccessControlType {
        return this.FromId(1080);
    }
    /**
        Returns MVD Clearing Adjustment MVD User AccessControlType
    **/
    get MVDClearingAdjustmentMVDUser(): IAccessControlType {
        return this.FromId(1081);
    }
    /**
        Returns MVD Clearing Adjustment MVD Lead AccessControlType
    **/
    get MVDClearingAdjustmentMVDLead(): IAccessControlType {
        return this.FromId(1082);
    }
    /**
        Returns MVD Clearing Adjustment FMS User AccessControlType
    **/
    get MVDClearingAdjustmentFMSUser(): IAccessControlType {
        return this.FromId(1083);
    }
    /**
        Returns MVD Clearing Adjustment FMS Lead AccessControlType
    **/
    get MVDClearingAdjustmentFMSLead(): IAccessControlType {
        return this.FromId(1084);
    }
    /**
        Returns Allow ReCreate Artifact AccessControlType
    **/
    get AllowReCreateArtifact(): IAccessControlType {
        return this.FromId(1085);
    }
    /**
        Returns Mobile Identification Management AccessControlType
    **/
    get MobileIdentificationManagement(): IAccessControlType {
        return this.FromId(1086);
    }
    /**
        Returns CanRemoveACPCharacteristic AccessControlType
    **/
    get CanRemoveACPCharacteristic(): IAccessControlType {
        return this.FromId(1087);
    }
    /**
        Returns Edit Batch Management AccessControlType
    **/
    get EditBatchManagement(): IAccessControlType {
        return this.FromId(1088);
    }
    /**
        Returns MC Error Corrections AccessControlType
    **/
    get MCErrorCorrections(): IAccessControlType {
        return this.FromId(1089);
    }
    /**
        Returns Edit Driver Record AccessControlType
    **/
    get EditDriverRecord(): IAccessControlType {
        return this.FromId(1090);
    }
    /**
        Returns Validate USDOT Number AccessControlType
    **/
    get ValidateUSDOTNumber(): IAccessControlType {
        return this.FromId(1091);
    }
    /**
        Returns Delete Compliance Information AccessControlType
    **/
    get DeleteComplianceInformation(): IAccessControlType {
        return this.FromId(1092);
    }
    /**
        Returns Delete Prohibition Information AccessControlType
    **/
    get DeleteProhibitionInformation(): IAccessControlType {
        return this.FromId(1093);
    }
    /**
        Returns Update Customer Active Indicator AccessControlType
    **/
    get UpdCustomerActiveIndicator(): IAccessControlType {
        return this.FromId(1094);
    }
    /**
        Returns Allow Print Letter Option AccessControlType
    **/
    get AllowPrintLetterOption(): IAccessControlType {
        return this.FromId(1095);
    }
    /**
        Returns Allow MVD Now User Delete AccessControlType
    **/
    get AllowMVDNowUserDelete(): IAccessControlType {
        return this.FromId(1096);
    }
    /**
        Returns Upd Legacy Cust Number Id Type AccessControlType
    **/
    get UpdLegacyCustNumberIdType(): IAccessControlType {
        return this.FromId(1097);
    }
    /**
        Returns Allow Creation of IRP/IFTA Audit AccessControlType
    **/
    get AllowCreateIRPIFTAAudit(): IAccessControlType {
        return this.FromId(1098);
    }
    /**
        Returns Central Print Edit AccessControlType
    **/
    get CentralPrintEdit(): IAccessControlType {
        return this.FromId(1099);
    }
    /**
        Returns MVD Knowledge Test AccessControlType
    **/
    get MVDKnowledgeTest(): IAccessControlType {
        return this.FromId(1100);
    }
    /**
        Returns Can View Event History AccessControlType
    **/
    get CanViewEventHistory(): IAccessControlType {
        return this.FromId(1101);
    }
    /**
        Returns Can Manage OIG Vehicle Note AccessControlType
    **/
    get CanManageOIGVehNote(): IAccessControlType {
        return this.FromId(1102);
    }
    /**
        Returns IRP Audit Supervisor AccessControlType
    **/
    get IRPAuditSupervisor(): IAccessControlType {
        return this.FromId(1103);
    }
    /**
        Returns IFTA Supervisor AccessControlType
    **/
    get IFTASupervisor(): IAccessControlType {
        return this.FromId(1104);
    }
    /**
        Returns Can Edit Deceased Date AccessControlType
    **/
    get CanEditDeceasedDate(): IAccessControlType {
        return this.FromId(1105);
    }
    /**
        Returns Allow Creation Of IRP Services AccessControlType
    **/
    get AllowCreationOfIRPServices(): IAccessControlType {
        return this.FromId(1106);
    }
    /**
        Returns Allow Creation of IFTA Services AccessControlType
    **/
    get AllowCreationOfIFTAServices(): IAccessControlType {
        return this.FromId(1107);
    }
    /**
        Returns Manage IFTA Fuel Tax Report AccessControlType
    **/
    get ManageIFTAFuelTaxReport(): IAccessControlType {
        return this.FromId(1108);
    }
    /**
        Returns Delete TSA Response AccessControlType
    **/
    get DeleteTSAResponse(): IAccessControlType {
        return this.FromId(1109);
    }
    /**
        Returns DC Restrictions AccessControlType
    **/
    get DCRestrictions(): IAccessControlType {
        return this.FromId(1110);
    }
    /**
        Returns Add Update Fail Return Vehicle Incident Withdrawal AccessControlType
    **/
    get AddUpdFailRetVehIncWit(): IAccessControlType {
        return this.FromId(1111);
    }
    /**
        Returns Collections IFTA Cancellation Approver AccessControlType
    **/
    get CollectionsIFTACancelApprover(): IAccessControlType {
        return this.FromId(1112);
    }
    /**
        Returns Audit IFTA Cancellation Approver AccessControlType
    **/
    get AuditIFTACancellationApprover(): IAccessControlType {
        return this.FromId(1113);
    }
    /**
        Returns FTRU IFTA Cancellation Approver AccessControlType
    **/
    get FTRUIFTACancellationApprover(): IAccessControlType {
        return this.FromId(1114);
    }
    /**
        Returns Allow Dealer Rescission AccessControlType
    **/
    get AllowDealerRescission(): IAccessControlType {
        return this.FromId(1115);
    }
    /**
        Returns Allow CDL Escalation AccessControlType
    **/
    get AllowCDLEscalation(): IAccessControlType {
        return this.FromId(1116);
    }
    /**
        Returns Edit OOJ Credential AccessControlType
    **/
    get EditOOJCredential(): IAccessControlType {
        return this.FromId(1117);
    }
    /**
        Returns Delete OOJ Credential AccessControlType
    **/
    get DeleteOOJCredential(): IAccessControlType {
        return this.FromId(1118);
    }
    /**
        Returns Allow TeleMVD Recordings Download AccessControlType
    **/
    get AllowTeleMVDRecordingsDownload(): IAccessControlType {
        return this.FromId(1119);
    }
    /**
        Returns Allow  AccessControlType
    **/
    get Allow(): IAccessControlType {
        return this.FromId(1120);
    }
    /**
        Returns Allow Update Vehicle Insurance AccessControlType
    **/
    get AllowUpdateVehicleInsurance(): IAccessControlType {
        return this.FromId(1121);
    }
    /**
        Returns CDL Service Transfer Information AccessControlType
    **/
    get CDLServiceTransferInformation(): IAccessControlType {
        return this.FromId(1122);
    }
    /**
        Returns Allow Edit MVD Support Review AccessControlType
    **/
    get AllowEditMVDSupportReview(): IAccessControlType {
        return this.FromId(1123);
    }
    /**
        Returns Allow View TeleMVD Feedback AccessControlType
    **/
    get AllowViewTeleMVDFeedback(): IAccessControlType {
        return this.FromId(1124);
    }
    /**
        Returns Allow deletion of scanned documents AccessControlType
    **/
    get AllowDeleteScannedDocs(): IAccessControlType {
        return this.FromId(1125);
    }
    /**
        Returns Waive POS Device Requirement AccessControlType
    **/
    get WaivePOSDeviceRequirement(): IAccessControlType {
        return this.FromId(1127);
    }
    /**
        Returns Allow Examiner Update AccessControlType
    **/
    get AllowExaminerUpdate(): IAccessControlType {
        return this.FromId(1128);
    }
    /**
        Returns Upd ATP Branch Application AccessControlType
    **/
    get UpdATPBranchApplication(): IAccessControlType {
        return this.FromId(1129);
    }
    /**
        Returns Upd ATP Employee Application AccessControlType
    **/
    get UpdATPEmployeeApplication(): IAccessControlType {
        return this.FromId(1130);
    }
    /**
        Returns Quality Check Queue Regions AccessControlType
    **/
    get QualityCheckQueueRegions(): IAccessControlType {
        return this.FromId(1131);
    }
    /**
        Returns Quality Check Dispute AccessControlType
    **/
    get QualityCheckDispute(): IAccessControlType {
        return this.FromId(1132);
    }
    /**
        Returns Allow Update AP - Conversion AccessControlType
    **/
    get AllowUpdateAPConversion(): IAccessControlType {
        return this.FromId(1133);
    }
    /**
        Returns ATPAgreementModify AccessControlType
    **/
    get ATPAgreementModify(): IAccessControlType {
        return this.FromId(1134);
    }
    /**
        Returns ATP Bond Modify AccessControlType
    **/
    get ATPBondModify(): IAccessControlType {
        return this.FromId(1135);
    }
    /**
        Returns ATP Business Hour Modify AccessControlType
    **/
    get ATPBusinessHourModify(): IAccessControlType {
        return this.FromId(1136);
    }
    /**
        Returns ATP Certificate Modify AccessControlType
    **/
    get ATPCertificateModify(): IAccessControlType {
        return this.FromId(1137);
    }
    /**
        Returns ATP Contact Modify AccessControlType
    **/
    get ATPContactModify(): IAccessControlType {
        return this.FromId(1138);
    }
    /**
        Returns ATP Finance Modify AccessControlType
    **/
    get ATPFinanceModify(): IAccessControlType {
        return this.FromId(1139);
    }
    /**
        Returns ATP Search Employee AccessControlType
    **/
    get ATPSearchEmployee(): IAccessControlType {
        return this.FromId(1140);
    }
    /**
        Returns ATP Document Modify AccessControlType
    **/
    get ATPDocumentModify(): IAccessControlType {
        return this.FromId(1141);
    }
    /**
        Returns ATP Document Requirement Modify AccessControlType
    **/
    get ATPDocumentRequirementModify(): IAccessControlType {
        return this.FromId(1142);
    }
    /**
        Returns ATP Document Status Modify AccessControlType
    **/
    get ATPDocumentStatusModify(): IAccessControlType {
        return this.FromId(1143);
    }
    /**
        Returns ATP Employment Modify AccessControlType
    **/
    get ATPEmploymentModify(): IAccessControlType {
        return this.FromId(1144);
    }
    /**
        Returns ATP Inspection Modify AccessControlType
    **/
    get ATPInspectionModify(): IAccessControlType {
        return this.FromId(1145);
    }
    /**
        Returns ATP Insurance Modify AccessControlType
    **/
    get ATPInsuranceModify(): IAccessControlType {
        return this.FromId(1146);
    }
    /**
        Returns ATP Location Modify AccessControlType
    **/
    get ATPLocationModify(): IAccessControlType {
        return this.FromId(1147);
    }
    /**
        Returns ATP Note Modify AccessControlType
    **/
    get ATPNoteModify(): IAccessControlType {
        return this.FromId(1148);
    }
    /**
        Returns ATP Owner Modify AccessControlType
    **/
    get ATPOwnerModify(): IAccessControlType {
        return this.FromId(1149);
    }
    /**
        Returns ATPCore AccessControlType
    **/
    get ATPCore(): IAccessControlType {
        return this.FromId(1150);
    }
    /**
        Returns Quality Check Error Resolution QA AccessControlType
    **/
    get QualityCheckErrorResolutionQA(): IAccessControlType {
        return this.FromId(1151);
    }
    /**
        Returns Quality Check Error Resolution TPA AccessControlType
    **/
    get QualityCheckErrorResolutionTPA(): IAccessControlType {
        return this.FromId(1152);
    }
    /**
        Returns Allow Waive NRII AccessControlType
    **/
    get AllowWaiveNRII(): IAccessControlType {
        return this.FromId(1153);
    }
    /**
        Returns ATP Agreement Add AccessControlType
    **/
    get ATPAgreementAdd(): IAccessControlType {
        return this.FromId(1154);
    }
    /**
        Returns Can Reset Fleet Expiration Date AccessControlType
    **/
    get CanResetFleetExpirationDate(): IAccessControlType {
        return this.FromId(1155);
    }
    /**
        Returns Add New Notification AccessControlType
    **/
    get AddNewNotification(): IAccessControlType {
        return this.FromId(1156);
    }
    /**
        Returns Safety and Security Queue Edit AccessControlType
    **/
    get SafetyAndSecurityQueueEdit(): IAccessControlType {
        return this.FromId(1158);
    }
    /**
        Returns Allow Remove Medical Certificate AccessControlType
    **/
    get AllowRemoveMedicalCertificate(): IAccessControlType {
        return this.FromId(1159);
    }
    /**
        Returns Can Edit DACH Prohibition AccessControlType
    **/
    get CanEditDACHProhibition(): IAccessControlType {
        return this.FromId(1160);
    }
    /**
        Returns Can Edit Authorized Presence Residency Type AccessControlType
    **/
    get EditAuthPresenceResidency(): IAccessControlType {
        return this.FromId(1161);
    }
    /**
        Returns Allow Edit Incident Conviction Credentials AccessControlType
    **/
    get AllowEditConvictionCredentials(): IAccessControlType {
        return this.FromId(1162);
    }
    /**
        Returns Upload To Mobile Home Record AccessControlType
    **/
    get UploadToMobileHomeRecord(): IAccessControlType {
        return this.FromId(1163);
    }
    /**
       Returns Blue Envelope View AccessControlType
   **/
    get BlueEnvelopeView(): IAccessControlType {
        return this.FromId(1164);
    }
    /**
     Returns Blue Envelope View AccessControlType
 **/
    get BlueEnvelopeEdit(): IAccessControlType {
        return this.FromId(1165);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'AllowUnbalancedReceipt', displayValue: 'Allow Unbalanced Receipt', description: 'Allow Unbalanced Receipt', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'AllowLongMessage', displayValue: 'Allow Long Message', description: 'Allows system to display longer messages for SSC users', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'UpdCustDetail', displayValue: 'Upd Cust Detail', description: 'Update Customer Detail', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'UpdCustName', displayValue: 'Upd Cust Name', description: 'Update Customer Name', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'UpdCustAddress', displayValue: 'Upd Cust Address', description: 'Update Customer Address', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'UpdCustIdentification', displayValue: 'Upd Cust Identification', description: 'Update Customer Identification', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'UpdCustCertification', displayValue: 'Upd Cust Certification', description: 'Update Customer Certification', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'UpdCustContact', displayValue: 'Upd Cust Contact', description: 'Update Customer Contact', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'UpdCustCharacteristic', displayValue: 'Upd Cust Characteristic', description: 'Update Customer Characteristic', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'UpdCustPhysicalAttributes', displayValue: 'Upd Cust Physical Attributes', description: 'Update Customer Physical Attributes', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'UpdCustMedical', displayValue: 'Upd Cust Medical', description: 'Update Customer Medical', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, value: 'UpdCustAffiliations', displayValue: 'Upd Cust Affiliations', description: 'Update Customer Affiliations', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, value: 'SetAddressUndeliverable', displayValue: 'Set Address Undeliverable', description: 'Set Address Undeliverable', sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, value: 'UpdACP', displayValue: 'Upd ACP', description: 'Update ACP', sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, value: 'UpdAbandonedVehicle', displayValue: 'Upd Abandoned Vehicle', description: 'Upd Abandoned Vehicle', sortOrder: 15, active: true });
        this._dictionary.add('16', { id: 16, value: 'UpdAccidentProcessing', displayValue: 'Upd Accident Processing', description: 'Upd Accident Processing', sortOrder: 16, active: true });
        this._dictionary.add('17', { id: 17, value: 'UpdCustomerComplaint', displayValue: 'Upd Customer Complaint', description: 'Upd Customer Complaint', sortOrder: 17, active: true });
        this._dictionary.add('18', { id: 18, value: 'UpdMedicalReview', displayValue: 'Upd Medical Review', description: 'Upd Medical Review', sortOrder: 18, active: true });
        this._dictionary.add('19', { id: 19, value: 'AllowPPVMainframeAdjust', displayValue: 'Allow PPV Mainframe Adjust', description: 'Allow a user to perform a prepaid voucher mainframe adjustment', sortOrder: 19, active: true });
        this._dictionary.add('21', { id: 21, value: 'AllowLawEnfNoteEdit', displayValue: 'Allow Law Enf Note Edit', description: 'Allow Law Enforcement Note Edit', sortOrder: 20, active: true });
        this._dictionary.add('22', { id: 22, value: 'AllowViewRedactedData', displayValue: 'Allow View Redacted Data', description: 'Allow View Redacted Data', sortOrder: 20, active: true });
        this._dictionary.add('1021', { id: 1021, value: 'AllowPPVDateRangeSearch', displayValue: 'Allow PPV Date Range Search', description: 'Allow PPV Date Range Search', sortOrder: 23, active: true });
        this._dictionary.add('1022', { id: 1022, value: 'CSRDLRestrictions', displayValue: 'CSR DL Restrictions', description: 'Set Certain DL Restrictions', sortOrder: 24, active: true });
        this._dictionary.add('1023', { id: 1023, value: 'CSRCDLRestrictions', displayValue: 'CSR CDL Restrictions', description: 'Set Certain CDL Restrictions', sortOrder: 25, active: true });
        this._dictionary.add('1024', { id: 1024, value: 'SetCRestrictionOnLicense', displayValue: 'Set C Restriction on License', description: 'Set C Restriction on License', sortOrder: 26, active: false });
        this._dictionary.add('1025', { id: 1025, value: 'SetDRestrictionOnLicense', displayValue: 'Set D Restriction on License', description: 'Set D Restriction on License', sortOrder: 27, active: false });
        this._dictionary.add('1026', { id: 1026, value: 'MRPRestrictions', displayValue: 'MRP Restrictions', description: 'Set Medical Review Program Restrictions', sortOrder: 28, active: true });
        this._dictionary.add('1027', { id: 1027, value: 'LECURestrictions', displayValue: 'LECU Restrictions', description: 'Set LECU Restrictions', sortOrder: 29, active: true });
        this._dictionary.add('1028', { id: 1028, value: 'DEVGroup', displayValue: 'DEV Restrictions Group', description: 'Set Developer Restrictions', sortOrder: 30, active: false });
        this._dictionary.add('1029', { id: 1029, value: 'DriverServicesRestrictions', displayValue: 'Driver Services Restrictions', description: 'Set Driver Services Restrictions', sortOrder: 31, active: true });
        this._dictionary.add('1030', { id: 1030, value: 'SetIRestrictionOnLicense', displayValue: 'Set I Restriction on License', description: 'Set I Restriction on License', sortOrder: 32, active: false });
        this._dictionary.add('1031', { id: 1031, value: 'SetJRestrictionOnLicense', displayValue: 'Set J Restriction on License', description: 'Set J Restriction on License', sortOrder: 33, active: false });
        this._dictionary.add('1032', { id: 1032, value: 'SetKRestrictionOnLicense', displayValue: 'Set K Restriction on License', description: 'Set K Restriction on License', sortOrder: 34, active: false });
        this._dictionary.add('1033', { id: 1033, value: 'SetLRestrictionOnLicense', displayValue: 'Set L Restriction on License', description: 'Set L Restriction on License', sortOrder: 35, active: false });
        this._dictionary.add('1034', { id: 1034, value: 'SetMRestrictionOnLicense', displayValue: 'Set M Restriction on License', description: 'Set M Restriction on License', sortOrder: 36, active: false });
        this._dictionary.add('1035', { id: 1035, value: 'SetNRestrictionOnLicense', displayValue: 'Set N Restriction on License', description: 'Set N Restriction on License', sortOrder: 37, active: false });
        this._dictionary.add('1036', { id: 1036, value: 'SetORestrictionOnLicense', displayValue: 'Set O Restriction on License', description: 'Set O Restriction on License', sortOrder: 38, active: false });
        this._dictionary.add('1037', { id: 1037, value: 'SetPRestrictionOnLicense', displayValue: 'Set P Restriction on License', description: 'Set P Restriction on License', sortOrder: 39, active: false });
        this._dictionary.add('1038', { id: 1038, value: 'SetQRestrictionOnLicense', displayValue: 'Set Q Restriction on License', description: 'Set Q Restriction on License', sortOrder: 40, active: false });
        this._dictionary.add('1039', { id: 1039, value: 'SetRRestrictionOnLicense', displayValue: 'Set R Restriction on License', description: 'Set R Restriction on License', sortOrder: 41, active: false });
        this._dictionary.add('1040', { id: 1040, value: 'SetSRestrictionOnLicense', displayValue: 'Set S Restriction on License', description: 'Set S Restriction on License', sortOrder: 42, active: false });
        this._dictionary.add('1041', { id: 1041, value: 'SetTRestrictionOnLicense', displayValue: 'Set T Restriction on License', description: 'Set T Restriction on License', sortOrder: 43, active: false });
        this._dictionary.add('1042', { id: 1042, value: 'SetVRestrictionOnLicense', displayValue: 'Set V Restriction on License', description: 'Set V Restriction on License', sortOrder: 45, active: false });
        this._dictionary.add('1043', { id: 1043, value: 'SetWRestrictionOnLicense', displayValue: 'Set W Restriction on License', description: 'Set W Restriction on License', sortOrder: 46, active: false });
        this._dictionary.add('1044', { id: 1044, value: 'SetXRestrictionOnLicense', displayValue: 'Set X Restriction on License', description: 'Set X Restriction on License', sortOrder: 47, active: false });
        this._dictionary.add('1045', { id: 1045, value: 'SetYRestrictionOnLicense', displayValue: 'Set Y Restriction on License', description: 'Set Y Restriction on License', sortOrder: 48, active: false });
        this._dictionary.add('1046', { id: 1046, value: 'SetZRestrictionOnLicense', displayValue: 'Set Z Restriction on License', description: 'Set Z Restriction on License', sortOrder: 49, active: false });
        this._dictionary.add('1047', { id: 1047, value: 'Set1RestrictionOnLicense', displayValue: 'Set 1 Restriction on License', description: 'Set 1 Restriction on License', sortOrder: 50, active: false });
        this._dictionary.add('1048', { id: 1048, value: 'Set2RestrictionOnLicense', displayValue: 'Set 2 Restriction on License', description: 'Set 2 Restriction on License', sortOrder: 51, active: false });
        this._dictionary.add('1049', { id: 1049, value: 'Set3RestrictionOnLicense', displayValue: 'Set 3 Restriction on License', description: 'Set 3 Restriction on License', sortOrder: 52, active: false });
        this._dictionary.add('1050', { id: 1050, value: 'Set4RestrictionOnLicense', displayValue: 'Set 4 Restriction on License', description: 'Set 4 Restriction on License', sortOrder: 53, active: false });
        this._dictionary.add('1051', { id: 1051, value: 'Set5RestrictionOnLicense', displayValue: 'Set 5 Restriction on License', description: 'Set 5 Restriction on License', sortOrder: 54, active: false });
        this._dictionary.add('1052', { id: 1052, value: 'Set6RestrictionOnLicense', displayValue: 'Set 6 Restriction on License', description: 'Set 6 Restriction on License', sortOrder: 55, active: false });
        this._dictionary.add('1053', { id: 1053, value: 'AllowViewFullSSN', displayValue: 'Allow View Full SSN', description: 'Allow View Full SSN', sortOrder: 56, active: true });
        this._dictionary.add('1055', { id: 1055, value: 'UpdCustRepresentatives', displayValue: 'Update Customer Representatives', description: 'Update Customer Representatives', sortOrder: 9999, active: true });
        this._dictionary.add('1126', { id: 1126, value: 'AllowMergeCustomer', displayValue: 'Allow Merge Customer', description: 'Allow Merge Customer', sortOrder: 99999, active: true });
        this._dictionary.add('1157', { id: 1157, value: 'QualityCheckUpdateAssignedTo', displayValue: 'Quality Check Update Assigned To', description: 'Allows Quality Check Queue Assigned To to be updated', sortOrder: 99999, active: true });
        this._dictionary.add('20', { id: 20, value: 'UpdCommercialVehicleTripAuth', displayValue: 'Upd Commercial Vehicle Trip Auth', description: 'Update Commercial Vehicle Trip Auth', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: 'AllowRefundCompliance', displayValue: 'Allow Refund Compliance', description: 'Allow Refund Compliance', sortOrder: 999999, active: true });
        this._dictionary.add('1054', { id: 1054, value: 'AllowViewUCVehicles', displayValue: 'Allow View UC Vehicles', description: 'Allow user to view UC Vehicles', sortOrder: 999999, active: true });
        this._dictionary.add('1056', { id: 1056, value: 'AllowAddAZDL', displayValue: 'Allow Add AZ DL', description: 'Allow user to manually add a DL or ID number when record could not be converted', sortOrder: 999999, active: true });
        this._dictionary.add('1057', { id: 1057, value: 'UpdOOPIAH', displayValue: 'Update OOP IAH', description: 'Update and view addresses for OOP IAH customers', sortOrder: 999999, active: true });
        this._dictionary.add('1058', { id: 1058, value: 'UpdRestrictedRecord', displayValue: 'Update Restricted Record', description: 'Update and view Restricted Record addresses for customers', sortOrder: 999999, active: true });
        this._dictionary.add('1059', { id: 1059, value: 'EnterTSASecurityAssessment', displayValue: 'Enter TSA Security Assessment', description: 'Enter and view history of TSA Security Assessments for a customer', sortOrder: 999999, active: true });
        this._dictionary.add('1060', { id: 1060, value: 'ApproveFuelTaxAssessment', displayValue: 'Approve Fuel Tax Assessment', description: 'Allows approval of Fuel Tax Assessments', sortOrder: 999999, active: true });
        this._dictionary.add('1061', { id: 1061, value: 'ApproveFuelTaxAdjustment', displayValue: 'Approve Fuel Tax Adjustment', description: 'Allows approval of Fuel Tax Adjustments', sortOrder: 999999, active: true });
        this._dictionary.add('1062', { id: 1062, value: 'FTManager', displayValue: 'FT Manager', description: 'FT Manager', sortOrder: 999999, active: true });
        this._dictionary.add('1063', { id: 1063, value: 'FTSupervisor', displayValue: 'FT Supervisor', description: 'FT Supervisor', sortOrder: 999999, active: true });
        this._dictionary.add('1064', { id: 1064, value: 'FTLead', displayValue: 'FT Lead', description: 'FT Lead', sortOrder: 999999, active: true });
        this._dictionary.add('1065', { id: 1065, value: 'SetELTIdentType', displayValue: 'Set ELT Identification Type on Customer', description: 'Set ELT Identification Type on Customer', sortOrder: 999999, active: true });
        this._dictionary.add('1066', { id: 1066, value: 'DriversIssuanceNoPhoto', displayValue: 'Drivers Issuance No Photo', description: 'Drivers Issuance No Photo', sortOrder: 999999, active: true });
        this._dictionary.add('1067', { id: 1067, value: 'CredentialPhotoAdmin', displayValue: 'Credential Photo Admin', description: 'Credential Photo Admin', sortOrder: 999999, active: true });
        this._dictionary.add('1068', { id: 1068, value: 'AllowPlateOrderStatusUpdate', displayValue: 'Allow Plate Order Status Update', description: 'Allow Plate Order Status Update', sortOrder: 999999, active: true });
        this._dictionary.add('1069', { id: 1069, value: 'UpdIRPIndicator', displayValue: 'Upd IRP Indicator', description: 'Allow user to update IRP Indicator', sortOrder: 999999, active: true });
        this._dictionary.add('1070', { id: 1070, value: 'AddUpdComplianceMonitoring', displayValue: 'Add/Update Compliance Monitoring', description: 'Add/Update Compliance Monitoring', sortOrder: 999999, active: true });
        this._dictionary.add('1071', { id: 1071, value: 'FRHold', displayValue: 'Folio Request Hold', description: 'Allows to set folio status to hold while in review.', sortOrder: 999999, active: true });
        this._dictionary.add('1072', { id: 1072, value: 'AllowTransferLockedCredit', displayValue: 'Allow Transfer Of Locked Credit', description: 'Allow Transfer Of Locked Credit', sortOrder: 999999, active: true });
        this._dictionary.add('1073', { id: 1073, value: 'AllowViewConfidentialNote', displayValue: 'Allow viewing of confidential notes', description: 'Allow viewing of confidential notes', sortOrder: 999999, active: true });
        this._dictionary.add('1074', { id: 1074, value: 'AllowCreateFinanceIncident', displayValue: 'Allow Creation of Finance Incidents', description: 'Allow Creation of Finance Incidents', sortOrder: 999999, active: true });
        this._dictionary.add('1075', { id: 1075, value: 'AllowCreateDupVin', displayValue: 'Allow Creation of a duplicate 17 digit VIN', description: 'Allow Creation of a duplicate 17 digit VIN', sortOrder: 999999, active: true });
        this._dictionary.add('1076', { id: 1076, value: 'PreviewFeatureOne', displayValue: 'Preview Feature One', description: 'Preview Feature One', sortOrder: 999999, active: true });
        this._dictionary.add('1077', { id: 1077, value: 'AddUpdFrdIncidentWithdrawal', displayValue: 'Add Update Fraud Incident Withdrawal', description: 'Add Update Fraud Incident Withdrawal', sortOrder: 999999, active: true });
        this._dictionary.add('1078', { id: 1078, value: 'AllowViewOmniSearchBar', displayValue: 'Allow View Omni Search Bar', description: 'Allows users access omni search bar/advanced search button', sortOrder: 999999, active: true });
        this._dictionary.add('1079', { id: 1079, value: 'EditDispositionCode78', displayValue: 'Edit Disposition Code 78', description: 'Edit Disposition Code 78 Expungement Dismissal Of Complaint', sortOrder: 999999, active: true });
        this._dictionary.add('1080', { id: 1080, value: 'AccommodativeMedicalSnapshot', displayValue: 'Accommodative Medical Snapshot', description: 'View Accommodative Medical Snapshot Tab', sortOrder: 999999, active: true });
        this._dictionary.add('1081', { id: 1081, value: 'MVDClearingAdjustmentMVDUser', displayValue: 'MVD Clearing Adjustment MVD User', description: 'MVD Clearing Adjustment MVD User', sortOrder: 999999, active: true });
        this._dictionary.add('1082', { id: 1082, value: 'MVDClearingAdjustmentMVDLead', displayValue: 'MVD Clearing Adjustment MVD Lead', description: 'MVD Clearing Adjustment MVD Lead', sortOrder: 999999, active: true });
        this._dictionary.add('1083', { id: 1083, value: 'MVDClearingAdjustmentFMSUser', displayValue: 'MVD Clearing Adjustment FMS User', description: 'MVD Clearing Adjustment FMS User', sortOrder: 999999, active: true });
        this._dictionary.add('1084', { id: 1084, value: 'MVDClearingAdjustmentFMSLead', displayValue: 'MVD Clearing Adjustment FMS Lead', description: 'MVD Clearing Adjustment FMS Lead', sortOrder: 999999, active: true });
        this._dictionary.add('1085', { id: 1085, value: 'AllowReCreateArtifact', displayValue: 'Allow ReCreate Artifact', description: 'Allow ReCreate Artifact', sortOrder: 999999, active: true });
        this._dictionary.add('1086', { id: 1086, value: 'MobileIdentificationManagement', displayValue: 'Mobile Identification Management', description: 'Mobile Identification Management', sortOrder: 999999, active: true });
        this._dictionary.add('1087', { id: 1087, value: 'CanRemoveACPCharacteristic', displayValue: 'CanRemoveACPCharacteristic', description: 'CanRemoveACPCharacteristic', sortOrder: 999999, active: true });
        this._dictionary.add('1088', { id: 1088, value: 'EditBatchManagement', displayValue: 'Edit Batch Management', description: 'Update, enable and trigger batch jobs in Batch Management.', sortOrder: 999999, active: false });
        this._dictionary.add('1089', { id: 1089, value: 'MCErrorCorrections', displayValue: 'MC Error Corrections', description: 'Motor Carrier Error Corrections', sortOrder: 999999, active: true });
        this._dictionary.add('1090', { id: 1090, value: 'EditDriverRecord', displayValue: 'Edit Driver Record', description: 'Edit Driver Record', sortOrder: 999999, active: true });
        this._dictionary.add('1091', { id: 1091, value: 'ValidateUSDOTNumber', displayValue: 'Validate USDOT Number', description: 'Validate USDOT Number', sortOrder: 999999, active: true });
        this._dictionary.add('1092', { id: 1092, value: 'DeleteComplianceInformation', displayValue: 'Delete Compliance Information', description: 'Delete Compliance Information', sortOrder: 999999, active: true });
        this._dictionary.add('1093', { id: 1093, value: 'DeleteProhibitionInformation', displayValue: 'Delete Prohibition Information', description: 'Delete Prohibition Information', sortOrder: 999999, active: true });
        this._dictionary.add('1094', { id: 1094, value: 'UpdCustomerActiveIndicator', displayValue: 'Update Customer Active Indicator', description: 'Updates customer Active/Inactive Indicator', sortOrder: 999999, active: true });
        this._dictionary.add('1095', { id: 1095, value: 'AllowPrintLetterOption', displayValue: 'Allow Print Letter Option', description: 'allows users to set printer letter option', sortOrder: 999999, active: true });
        this._dictionary.add('1096', { id: 1096, value: 'AllowMVDNowUserDelete', displayValue: 'Allow MVD Now User Delete', description: 'Grants access to unlink and delete MVD Now users from the mvd now user managemnet form', sortOrder: 999999, active: true });
        this._dictionary.add('1097', { id: 1097, value: 'UpdLegacyCustNumberIdType', displayValue: 'Upd Legacy Cust Number Id Type', description: 'allows ability to modify and end date Legacy Customer Number identification type', sortOrder: 999999, active: true });
        this._dictionary.add('1098', { id: 1098, value: 'AllowCreateIRPIFTAAudit', displayValue: 'Allow Creation of IRP/IFTA Audit', description: 'Allow Creation of IRP/IFTA Audit', sortOrder: 999999, active: true });
        this._dictionary.add('1099', { id: 1099, value: 'CentralPrintEdit', displayValue: 'Central Print Edit', description: 'Allows QUeue, Job Actions, and Requeue Job', sortOrder: 999999, active: true });
        this._dictionary.add('1100', { id: 1100, value: 'MVDKnowledgeTest', displayValue: 'MVD Knowledge Test', description: 'Assign MVD knowledge test ', sortOrder: 999999, active: true });
        this._dictionary.add('1101', { id: 1101, value: 'CanViewEventHistory', displayValue: 'Can View Event History', description: 'allows button Event History from a customer record', sortOrder: 999999, active: true });
        this._dictionary.add('1102', { id: 1102, value: 'CanManageOIGVehNote', displayValue: 'Can Manage OIG Vehicle Note', description: 'Can Manage OIG Vehicle Note', sortOrder: 999999, active: true });
        this._dictionary.add('1103', { id: 1103, value: 'IRPAuditSupervisor', displayValue: 'IRP Audit Supervisor', description: 'IRP Audit Supervisor', sortOrder: 999999, active: true });
        this._dictionary.add('1104', { id: 1104, value: 'IFTASupervisor', displayValue: 'IFTA Supervisor', description: 'IFTA Supervisor', sortOrder: 999999, active: true });
        this._dictionary.add('1105', { id: 1105, value: 'CanEditDeceasedDate', displayValue: 'Can Edit Deceased Date', description: 'Can Edit Deceased Date', sortOrder: 999999, active: true });
        this._dictionary.add('1106', { id: 1106, value: 'AllowCreationOfIRPServices', displayValue: 'Allow Creation Of IRP Services', description: 'Allow Creation Of IRP Services', sortOrder: 999999, active: true });
        this._dictionary.add('1107', { id: 1107, value: 'AllowCreationOfIFTAServices', displayValue: 'Allow Creation of IFTA Services', description: 'Allow Creation of IFTA Services', sortOrder: 999999, active: true });
        this._dictionary.add('1108', { id: 1108, value: 'ManageIFTAFuelTaxReport', displayValue: 'Manage IFTA Fuel Tax Report', description: 'Manage IFTA Fuel Tax Report', sortOrder: 999999, active: true });
        this._dictionary.add('1109', { id: 1109, value: 'DeleteTSAResponse', displayValue: 'Delete TSA Response', description: 'Delete TSA Response', sortOrder: 999999, active: true });
        this._dictionary.add('1110', { id: 1110, value: 'DCRestrictions', displayValue: 'DC Restrictions', description: 'Driver Compliance Restrictions', sortOrder: 999999, active: true });
        this._dictionary.add('1111', { id: 1111, value: 'AddUpdFailRetVehIncWit', displayValue: 'Add Update Fail Return Vehicle Incident Withdrawal', description: 'Add or Update Failure To Return Vehicle Incidents and Withdrawals', sortOrder: 999999, active: true });
        this._dictionary.add('1112', { id: 1112, value: 'CollectionsIFTACancelApprover', displayValue: 'Collections IFTA Cancellation Approver', description: 'Collections IFTA Cancellation Approver', sortOrder: 999999, active: true });
        this._dictionary.add('1113', { id: 1113, value: 'AuditIFTACancellationApprover', displayValue: 'Audit IFTA Cancellation Approver', description: 'Audit IFTA Cancellation Approver', sortOrder: 999999, active: true });
        this._dictionary.add('1114', { id: 1114, value: 'FTRUIFTACancellationApprover', displayValue: 'FTRU IFTA Cancellation Approver', description: 'FTRU IFTA Cancellation Approver', sortOrder: 999999, active: true });
        this._dictionary.add('1115', { id: 1115, value: 'AllowDealerRescission', displayValue: 'Allow Dealer Rescission', description: 'Allow Dealer Rescission', sortOrder: 999999, active: true });
        this._dictionary.add('1116', { id: 1116, value: 'AllowCDLEscalation', displayValue: 'Allow CDL Escalation', description: 'Sends CDL issance to CDL business unit', sortOrder: 999999, active: true });
        this._dictionary.add('1117', { id: 1117, value: 'EditOOJCredential', displayValue: 'Edit OOJ Credential', description: 'Edit out of jurisdiction driver credentials', sortOrder: 999999, active: true });
        this._dictionary.add('1118', { id: 1118, value: 'DeleteOOJCredential', displayValue: 'Delete OOJ Credential', description: 'Delete out of jurisdiction driver credentials', sortOrder: 999999, active: true });
        this._dictionary.add('1119', { id: 1119, value: 'AllowTeleMVDRecordingsDownload', displayValue: 'Allow TeleMVD Recordings Download', description: 'Allow TeleMVD Recordings Download', sortOrder: 999999, active: true });
        this._dictionary.add('1120', { id: 1120, value: 'Allow', displayValue: 'Allow ', description: 'Allow', sortOrder: 999999, active: false });
        this._dictionary.add('1121', { id: 1121, value: 'AllowUpdateVehicleInsurance', displayValue: 'Allow Update Vehicle Insurance', description: 'Allow Update Vehicle Insurance', sortOrder: 999999, active: true });
        this._dictionary.add('1122', { id: 1122, value: 'CDLServiceTransferInformation', displayValue: 'CDL Service Transfer Information', description: 'CDL Service Transfer Information', sortOrder: 999999, active: true });
        this._dictionary.add('1123', { id: 1123, value: 'AllowEditMVDSupportReview', displayValue: 'Allow Edit MVD Support Review', description: 'Allows CSR to edit MVD support Review Compliances', sortOrder: 999999, active: true });
        this._dictionary.add('1124', { id: 1124, value: 'AllowViewTeleMVDFeedback', displayValue: 'Allow View TeleMVD Feedback', description: 'Allow View TeleMVD Feedback', sortOrder: 999999, active: true });
        this._dictionary.add('1125', { id: 1125, value: 'AllowDeleteScannedDocs', displayValue: 'Allow deletion of scanned documents', description: 'Allow deletion of scanned documents', sortOrder: 999999, active: true });
        this._dictionary.add('1127', { id: 1127, value: 'WaivePOSDeviceRequirement', displayValue: 'Waive POS Device Requirement', description: 'Allows the user to opt out of choosing a POS device (in a BU that would normally require it)', sortOrder: 999999, active: true });
        this._dictionary.add('1128', { id: 1128, value: 'AllowExaminerUpdate', displayValue: 'Allow Examiner Update', description: 'Allow Examiner Update', sortOrder: 999999, active: true });
        this._dictionary.add('1129', { id: 1129, value: 'UpdATPBranchApplication', displayValue: 'Upd ATP Branch Application', description: 'Upd ATP Branch Application', sortOrder: 999999, active: true });
        this._dictionary.add('1130', { id: 1130, value: 'UpdATPEmployeeApplication', displayValue: 'Upd ATP Employee Application', description: 'Upd ATP Employee Application', sortOrder: 999999, active: true });
        this._dictionary.add('1131', { id: 1131, value: 'QualityCheckQueueRegions', displayValue: 'Quality Check Queue Regions', description: 'Allows users to search quality check queue by status.', sortOrder: 999999, active: true });
        this._dictionary.add('1132', { id: 1132, value: 'QualityCheckDispute', displayValue: 'Quality Check Dispute', description: 'Allows users to submit quality check disputes against errors identified by QC agents.', sortOrder: 999999, active: true });
        this._dictionary.add('1133', { id: 1133, value: 'AllowUpdateAPConversion', displayValue: 'Allow Update AP - Conversion', description: 'Allows user to set a customer’s Authorized Presence proof document type to AP - Conversion', sortOrder: 999999, active: true });
        this._dictionary.add('1134', { id: 1134, value: 'ATPAgreementModify', displayValue: 'ATPAgreementModify', description: 'Allows ATP Agreements to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1135', { id: 1135, value: 'ATPBondModify', displayValue: 'ATP Bond Modify', description: 'Allows ATP Bonds to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1136', { id: 1136, value: 'ATPBusinessHourModify', displayValue: 'ATP Business Hour Modify', description: 'Allows ATP Business Hours to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1137', { id: 1137, value: 'ATPCertificateModify', displayValue: 'ATP Certificate Modify', description: 'Allows ATP Certificates to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1138', { id: 1138, value: 'ATPContactModify', displayValue: 'ATP Contact Modify', description: 'Allows ATP Contacts to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1139', { id: 1139, value: 'ATPFinanceModify', displayValue: 'ATP Finance Modify', description: 'Allows ATP Finance to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1140', { id: 1140, value: 'ATPSearchEmployee', displayValue: 'ATP Search Employee', description: 'Allows ATP Search Employee functionality', sortOrder: 999999, active: true });
        this._dictionary.add('1141', { id: 1141, value: 'ATPDocumentModify', displayValue: 'ATP Document Modify', description: 'Allows ATP Documents to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1142', { id: 1142, value: 'ATPDocumentRequirementModify', displayValue: 'ATP Document Requirement Modify', description: 'Allows ATP Document Requirements to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1143', { id: 1143, value: 'ATPDocumentStatusModify', displayValue: 'ATP Document Status Modify', description: 'Allows ATP Document Status to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1144', { id: 1144, value: 'ATPEmploymentModify', displayValue: 'ATP Employment Modify', description: 'Allows ATP Employments to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1145', { id: 1145, value: 'ATPInspectionModify', displayValue: 'ATP Inspection Modify', description: 'Allows ATP Inspections to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1146', { id: 1146, value: 'ATPInsuranceModify', displayValue: 'ATP Insurance Modify', description: 'Allows ATP Insurance to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1147', { id: 1147, value: 'ATPLocationModify', displayValue: 'ATP Location Modify', description: 'Allows ATP Locations to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1148', { id: 1148, value: 'ATPNoteModify', displayValue: 'ATP Note Modify', description: 'Allows ATP Notes to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1149', { id: 1149, value: 'ATPOwnerModify', displayValue: 'ATP Owner Modify', description: 'Allows ATP Owners to be modified', sortOrder: 999999, active: true });
        this._dictionary.add('1150', { id: 1150, value: 'ATPCore', displayValue: 'ATPCore', description: 'Allows ATP Core functionality', sortOrder: 999999, active: true });
        this._dictionary.add('1151', { id: 1151, value: 'QualityCheckErrorResolutionQA', displayValue: 'Quality Check Error Resolution QA', description: 'Allows user to access QA areas of Quality Check', sortOrder: 999999, active: true });
        this._dictionary.add('1152', { id: 1152, value: 'QualityCheckErrorResolutionTPA', displayValue: 'Quality Check Error Resolution TPA', description: 'Allows user to access TPA areas of Quality Check', sortOrder: 999999, active: true });
        this._dictionary.add('1153', { id: 1153, value: 'AllowWaiveNRII', displayValue: 'Allow Waive NRII', description: 'Allows user to waive new NRII Requirement for Credential Issuance', sortOrder: 999999, active: true });
        this._dictionary.add('1154', { id: 1154, value: 'ATPAgreementAdd', displayValue: 'ATP Agreement Add', description: 'Allows ATP Agreements to be added', sortOrder: 999999, active: true });
        this._dictionary.add('1155', { id: 1155, value: 'CanResetFleetExpirationDate', displayValue: 'Can Reset Fleet Expiration Date', description: 'Can reset an intrastate fleet expiration date', sortOrder: 999999, active: true });
        this._dictionary.add('1156', { id: 1156, value: 'AddNewNotification', displayValue: 'Add New Notification', description: 'Allows an email notification to be added', sortOrder: 999999, active: true });
        this._dictionary.add('1158', { id: 1158, value: 'SafetyAndSecurityQueueEdit', displayValue: 'Safety and Security Queue Edit', description: 'Allows user to edit the Safety and Security Report', sortOrder: 999999, active: true });
        this._dictionary.add('1159', { id: 1159, value: 'AllowRemoveMedicalCertificate', displayValue: 'Allow Remove Medical Certificate', description: 'Allows the user to remove medical certificates', sortOrder: 999999, active: true });
        this._dictionary.add('1160', { id: 1160, value: 'CanEditDACHProhibition', displayValue: 'Can Edit DACH Prohibition', description: 'Allows user to edit DACH Prohibition', sortOrder: 999999, active: true });
        this._dictionary.add('1161', { id: 1161, value: 'EditAuthPresenceResidency', displayValue: 'Can Edit Authorized Presence Residency Type', description: 'Allows user to edit Authorized Presence Residency', sortOrder: 999999, active: true });
        this._dictionary.add('1162', { id: 1162, value: 'AllowEditConvictionCredentials', displayValue: 'Allow Edit Incident Conviction Credentials', description: 'Allow the user to edit incident conviction credentials', sortOrder: 999999, active: true });
        this._dictionary.add('1163', { id: 1163, value: 'UploadToMobileHomeRecord', displayValue: 'Upload To Mobile Home Record', description: 'Upload To Mobile Home Record', sortOrder: 999999, active: true });
        this._dictionary.add('1164', { id: 1164, value: 'BlueEnvelopeView', displayValue: 'Blue Envelope View', description: 'Allows the user to view Accommodation Characteristics', sortOrder: 999999, active: true });
        this._dictionary.add('1165', { id: 1165, value: 'BlueEnvelopeEdit', displayValue: 'Blue Envelope Edit', description: 'Allows the user to edit Accommodation Characteristics', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IAccessControlType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IAccessControlType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IAccessControlType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IAccessControlType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IAccessControlType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
